function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FA6358",
  fillOpacity: 0.15,
  d: "M89.92 45c0 24.853-20.13 45-44.96 45C20.13 90 0 69.853 0 45S20.13 0 44.96 0c24.83 0 44.96 20.147 44.96 45z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M67.939 26.66c-17.834 0-32.311 14.49-32.311 32.34s14.477 32.41 32.38 32.41c17.835 0 32.382-14.49 32.382-32.41-.07-17.85-14.617-32.34-32.451-32.34zm28.394 30.45H84.024c-.42-9.8-4.336-18.97-10.98-26.11 12.729 2.24 22.45 12.95 23.29 26.11zM67.94 86.72c-7.343-6.65-11.75-15.89-12.24-25.83h24.549c-.56 9.94-4.966 19.18-12.31 25.83zM55.7 57.11c.49-9.94 4.897-19.18 12.24-25.83 7.343 6.65 11.75 15.89 12.239 25.83H55.7zm7.065-26.18c-6.645 7.14-10.491 16.31-10.98 26.11h-12.24c.84-13.09 10.56-23.8 23.22-26.11zm-23.22 30.03h12.31c.419 9.8 4.336 18.97 10.98 26.11-12.73-2.31-22.45-13.02-23.29-26.11zm33.57 26.11c6.644-7.14 10.49-16.31 10.98-26.11h12.31c-.91 13.09-10.631 23.8-23.29 26.11z"
});

function SvgGlobeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 101 92"
  }, props), _ref, _ref2);
}

export default SvgGlobeinline;